export const DEFAULT_BINDER_COLOUR = '#33443D';
export const BINDER_COLOURS = [
  ['Forest green', DEFAULT_BINDER_COLOUR], ['Black', '#20242B'], ['Red', '#B91C1C'],
  ['Blue', '#1D4ED8'], ['Purple', '#7E22CE'], ['Teal', '#0F766E'],
  ['Pink', '#BE185D'], ['Yellow', '#EAB308'], ['White', '#F8FAFC'],
];

export function binderColour(value) {
  return /^#[0-9a-f]{6}$/i.test(value || '') ? value : DEFAULT_BINDER_COLOUR;
}

export function coverTextColour(value) {
  const hex = binderColour(value).slice(1);
  const [red, green, blue] = [0, 2, 4].map(start => parseInt(hex.slice(start, start + 2), 16));
  return red * .299 + green * .587 + blue * .114 > 160 ? '#1F2937' : '#FFFFFF';
}

export function BinderColourPicker({ value, onChange }) {
  const colour = binderColour(value);
  return <fieldset className="space-y-3 rounded-2xl border border-slate-200 p-4">
    <legend className="px-1 font-display font-bold">Binder colour</legend>
    <div className="flex flex-wrap gap-2">{BINDER_COLOURS.map(([name, hex]) => <button key={hex} type="button" aria-label={`${name} binder`} title={name} aria-pressed={colour.toLowerCase() === hex.toLowerCase()}
      onClick={() => onChange(hex)} className={`h-10 w-10 rounded-full border-2 shadow-sm ${colour.toLowerCase() === hex.toLowerCase() ? 'ring-2 ring-slate-900 ring-offset-2' : 'border-slate-200'}`} style={{ backgroundColor: hex }} />)}</div>
    <label className="flex items-center gap-3 text-sm font-semibold">Custom binder colour<input type="color" aria-label="Custom binder colour" value={colour} onChange={event => onChange(event.target.value)} className="h-10 w-14 cursor-pointer rounded border border-slate-200 bg-white p-1" /><span className="font-mono text-xs text-slate-500">{colour.toUpperCase()}</span></label>
  </fieldset>;
}
